<template>
    <div class="SearchedSEDetailsTableComponent DataTables">
        
        <p  v-if="localIsSE == true">{{ lang.infotext_1 }}:</p>
        <p  v-if="localIsSE == false">{{ lang.infotext_2 }}</p>
        <span v-if="localIsSE == false">
            <b-button @click="getDetailsManual" :variant="variant">{{lang.button_label_GetDataFromSE}}</b-button>
        </span>
        <span v-if="localIsSE == true">
            
            <div v-show="isData && oldStructure == true" :id="id"></div>
            
            <TreeSEComponent v-if="isData && oldStructure == false" :data="properties" :lang="lang.TreeSE"></TreeSEComponent>

            <b-button v-if="isData && oldStructure == false" @click="detailsRiskSE" :variant="variant">{{lang.button_label_SE_RiskDetails}}</b-button>
            <b-button v-if="isData && oldStructure == false" @click="syncPartSE" :variant="variant">{{lang.button_label_SyncPartSE}}</b-button>
            <b-button v-if="isData && oldStructure == false" @click="unassignPartSE" :variant="variant">{{lang.button_label_SE_unassign}}</b-button>

            <LoaderComponent v-if="!isData"></LoaderComponent>
        </span>
        

        

        

    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import TreeSEComponent from "@/components/shared/TreeSEComponent"

import $ from 'jquery';
import dt from 'datatables.net-bs4';
import { mapGetters } from 'vuex'


export default {
    name: "SearchedSEDetailsTableComponent",
    props: {
        lang: Object,
        parent: String,
        distributorPartId: String,
        isSE: Boolean
    },
    components: {
        TreeSEComponent,
        LoaderComponent
    },
    data() {
        return {
            name: "SearchedSEDetailsTableComponent",
            id: "tableplace_" + this._uid,
            columns: [],
            colsAssign: [],
            mainTable: "",
            searchedDetails: [],
            properties: [],
            isData: false,
            localIsSE: this.isSE,
            oldStructure: null,
            successSE: null,
            fullData: null
        }
    },
    computed: {
        // distributorPartId() {

        //     return this.$store.getters.selectedSearchedRows.DistributorPartId;

        // },
        selectedSearchedRows() {
            return this.$store.getters.selectedSearchedRows;
        },
        // isData() {

        //     return this.distributorPartId != undefined;

        // },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        reloadedAfterActionComplex() {
          return this.$store.getters.reloadedAfterActionComplex;
        },
    },
    created() {
        
        if (this.isSE == true){
            //this.getDetails();
            this.getDetailsByDPI();
        } 
        
        
    },
    watch: {
        distributorPartId: function (newVal) {
            

            if (this.localIsSE == true){
            
                this.getDetailsByDPI();
            }

        },
        reloadedAfterActionComplex: {
          handler: function (newValue) {
            
            for (let el in newValue) {

              if (newValue[el].name == this.name) {

                if (newValue[el].status == true) {

                    
                        
                        this.getDetailsByDPI();
                    

                  newValue[el].status = false;

                  this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                }
              }
            }
          },
          deep: true

        },
    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
        updateIsSE(value) {
            this.localIsSE = value; 
        },
        displayResult() {

            let vue = this;
            const data = {
                distributorPartId: this.distributorPartId
            }
            

            
            function funcYes() {
                                               

                const obj = {
                    distributorPartId: this.data.distributorPartId,
                    comId: vue.$store.getters.partSE.comId
                }
                

                vue.$store.dispatch("pm_assignPartSEToMPN", obj)
                    .then(function (result) {

                        console.log(result.data)
                        let obj = {};
                        if (result.status == "OK") {
                            
                            if (result.data != null) {
                                obj = {
                                    text: vue.lang.alert_success_AssignPartSEToMPN,
                                    time: 10,
                                    type: "success"
                                }

                                const reloadObj = {
                                    status: true,
                                    name: "SearchedSEDetailsTableComponent"
                                }
                                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                                


                            } else {
                                obj = {
                                    text: vue.lang.alert_error_AssignPartSEToMPN + ". ",
                                    time: 15,
                                    type: "danger"
                                }

                            }
                        } else {
                            obj = {
                                text: vue.lang.alert_error_AssignPartSEToMPN + ": " + result.message,
                                time: 15,
                                type: "danger"
                            }
                        }
                        vue.$store.dispatch("displayFooterAlert", obj);
                    })

            }

            const objModal = {
                ok: true,
                cancel: false
            }

            vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)

            var obj = {

            text: "",
            type: "se_suggestions",
            buttons: 2,
            //buttonName: "Close",
            size: "xxl",
            data: data,
            lang: this.lang.modal_SESuggestions,
            funcNo: "",
            funcYes: funcYes,
            funcCustom: ""
          };
          this.$store.dispatch("showModalComponent", obj);


        },
        
        getDetailsManual() {
            
            

            this.displayResult();

        },
        getDetailsByDPI() {

            let vue = this;

            const obj = {
                distributorPartId: this.distributorPartId
            }


            this.$store.dispatch("pm_getSEDetailsByDPI", [obj])
                .then(function (result) {

                    console.log(result.data)

                    if (result.status == "OK") {
                        vue.isData = true;

                        vue.fullData = result.data[0];
                        
                        vue.updateIsSE(result.data[0].isSE);

                        vue.successSE = result.data[0].success

                        if (result.data[0].seDetailsOld != null) {
                            vue.oldStructure = true;
                            vue.properties = result.data[0].seDetailsOld;
                            vue.buildColumns();
                        } else {
                            vue.properties = result.data[0].seDetails;
                            vue.oldStructure = false;
                        }
                        



                        
                    } else {
                        vue.isData = false;
                        
                        
                    }

                })

        },
        getDetails() {
            
            let vue = this;
            let obj = {};
            
            if (this.parent == "parts") {
                
                obj = {
                    manufacturerPartNumber: this.$store.getters.selectedAlternative.manufacturerPartNumber,
                    manufacturerName: this.$store.getters.selectedAlternative.manufacturerName
                    
                }
            } else {
                
                obj = {
                    manufacturerPartNumber: this.selectedSearchedRows.ManufacturerPartNumber,
                    manufacturerName: this.selectedSearchedRows.ManufacturerName
                    
                }
            }

            
            this.$store.dispatch("pm_getSEDetailsByMPN", obj)
                .then(function (result) {

                    console.log(result.data)

                    if (result.status == "OK") {
                        vue.isData = true;
                        vue.properties = result.data;


                        vue.buildColumns();
                    } else {
                        vue.isData = true;
                        vue.properties = [];
                        vue.buildColumns();
                    }

                })
        },
        unassignPartSE() {

            let _vue = this;

            

            function unassignFunc() {

                const obj = {
                    distributorPartId: _vue.distributorPartId
                }
                
                _vue.$store.dispatch("pm_unassignPartSEToMPN", obj)
                .then((result) => {

                    console.log(result)
                    let obj = {};
                    if (result.status == "OK") {

                        if (result.data != null) {
                            obj = {
                                text: _vue.lang.alert_success_unassignSEData,
                                time: 10,
                                type: "success"
                            }

                            const reloadObj = {
                                status: true,
                                name: "SearchedSEDetailsTableComponent"
                            }
                            _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                            


                        } else {
                            obj = {
                                text: _vue.lang.alert_error_unassignSEData + ". ",
                                time: 15,
                                type: "danger"
                            }

                        }
                    } else {
                        obj = {
                            text: _vue.lang.alert_error_unassignSEData + ": " + result.message,
                            time: 15,
                            type: "danger"
                        }

                    }
                    _vue.$store.dispatch("displayFooterAlert", obj);
                })
                
            }

            const obj = {
                title: _vue.lang.modal_title_unassignSEData,
                text: _vue.lang.alert_unassignSEData,
                type: "sure",
                buttons: 2,
                size: "sm",
                funcYes: unassignFunc,
                funcNo: ""
            };

            _vue.$store.dispatch("showAlert", obj);
                        
            
            
            
        },
        detailsRiskSE() {

          let vue = this;

          
            var obj = {

              text: "",
              type: "SERisk",
              buttons: 1,
              buttonName: "Close",
              size: "xl",
              data: this.fullData,
              lang: this.lang.modal_SERisk,
              funcNo: "",
              funcYes: "",
              funcCustom: ""
            };
            this.$store.dispatch("showModalComponent", obj);
        },
        syncPartSE() {

          
          let vue = this;

          const obj = {
            distributorPartId: this.distributorPartId
          }

          
          vue.$store.dispatch("pm_syncSE", obj)
          .then((result) => {

              console.log(result)
              let obj = {};
              if (result.status == "OK") {

                  if (result.data != null) {
                      obj = {
                          text: vue.lang.alert_success_SyncSEData,
                          time: 10,
                          type: "success"
                      }

                      const reloadObj = {
                          status: true,
                          name: "SearchedSEDetailsTableComponent"
                      }
                      vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                      


                  } else {
                      obj = {
                          text: vue.lang.alert_error_SyncSEData + ". ",
                          time: 15,
                          type: "danger"
                      }

                  }
              } else {
                  obj = {
                      text: vue.lang.alert_error_SyncSEData + ": " + result.message,
                      time: 15,
                      type: "danger"
                  }

              }
              vue.$store.dispatch("displayFooterAlert", obj);
          })
            
        },
        buildColumns() {

            this.colsAssign = [

                { "data": "name" },
                { "data": "value" },

            ]

            this.columns = [

                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Value,
                    alignInColumn: "left",

                },

            ]



            this.buildData();
        },

        buildData() {

            this.searchedDetails = [];
            
            
            for (let key in this.properties) {
                
                let row = {
                    name: key,
                    value: this.properties[key],
                    type: "text"
                };
                this.searchedDetails.push(row);

            }


            this.buildTable();
        },

        buildTable() {
            

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            table.setAttribute("style", "width:100%;");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;




            var columnDefs = [];

            for (let i = 0, len = this.columns.length; i < len; i++) {

                let classname = '_dt-body-' + this.columns[i].alignInColumn;

                let el = {
                    targets: i,
                    className: classname,
                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        if (meta.col == 0) {
                            return data;
                        }
                        if (meta.col == 1) {

                            let index = data.indexOf("http");
                            if (index > -1) {

                                return "<a target=\"blank\" href=\"" + data + "\">Link</a>";
                            }

                            // if (data == "Low") {
                            //     return "<b-badge class='badge badge-success' >" + data + "</b-badge>";
                            // }
                            // if (data == "Middle") {
                            //     return "<b-badge class='badge badge-warning' >" + data + "</b-badge>";
                            // }
                            // if (data == "High") {
                            //     return "<b-badge class='badge badge-danger' >" + data + "</b-badge>";
                            // }
                            return data;
                            

                        }
                        return data;
                    }
                }

                columnDefs.push(el);


                var th = document.createElement("th");
                tr.appendChild(th);
                var br = document.createElement("br");
                th.appendChild(br);

                var tx = document.createTextNode(this.columns[i].name)
                th.appendChild(tx);

            }

            const buttons = [
                {
                    text: _vue.lang.button_label_Details,
                    className: 'addButton btn-' + _vue.variant,
                    action: function (e, dt, node, config) {

                        var obj = {

                          text: "",
                          type: "SERisk",
                          buttons: 1,
                          buttonName: "Close",
                          size: "xl",
                          data: _vue.fullData,
                          lang: _vue.lang.modal_SERisk,
                          funcNo: "",
                          funcYes: "",
                          funcCustom: ""
                        };
                        _vue.$store.dispatch("showModalComponent", obj);
                        
                        
                    }
                },
                {
                    text: _vue.lang.button_label_SE_sync,
                    className: 'addButton btn-' + _vue.variant,
                    action: function (e, dt, node, config) {

                        

                        const obj = {
                                distributorPartId: _vue.distributorPartId
                            }

                            
                            _vue.$store.dispatch("pm_syncSE", obj)
                            .then((result) => {

                                console.log(result)
                                let obj = {};
                                if (result.status == "OK") {

                                    if (result.data != null) {
                                        obj = {
                                            text: _vue.lang.alert_success_SyncSEData,
                                            time: 10,
                                            type: "success"
                                        }

                                        const reloadObj = {
                                            status: true,
                                            name: "SearchedSEDetailsTableComponent"
                                        }
                                        _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                                        


                                    } else {
                                        obj = {
                                            text: _vue.lang.alert_error_SyncSEData + ". ",
                                            time: 15,
                                            type: "danger"
                                        }

                                    }
                                } else {
                                    obj = {
                                        text: _vue.lang.alert_error_SyncSEData + ": " + result.message,
                                        time: 15,
                                        type: "danger"
                                    }

                                }
                                _vue.$store.dispatch("displayFooterAlert", obj);
                            })
                        
                        
                    }
                },
                {
                    text: _vue.lang.button_label_SE_unassign,
                    className: 'addButton btn-' + _vue.variant,
                    action: function (e, dt, node, config) {

                        

                        let unassignFunc = function () {
                            
        
                            const obj = {
                                distributorPartId: _vue.distributorPartId
                            }

                            
                            _vue.$store.dispatch("pm_unassignPartSEToMPN", obj)
                            .then((result) => {

                                console.log(result)
                                let obj = {};
                                if (result.status == "OK") {

                                    if (result.data != null) {
                                        obj = {
                                            text: _vue.lang.alert_success_unassignSEData,
                                            time: 10,
                                            type: "success"
                                        }

                                        const reloadObj = {
                                            status: true,
                                            name: "SearchedSEDetailsTableComponent"
                                        }
                                        _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                                        


                                    } else {
                                        obj = {
                                            text: _vue.lang.alert_error_unassignSEData + ". ",
                                            time: 15,
                                            type: "danger"
                                        }

                                    }
                                } else {
                                    obj = {
                                        text: _vue.lang.alert_error_unassignSEData + ": " + result.message,
                                        time: 15,
                                        type: "danger"
                                    }

                                }
                                _vue.$store.dispatch("displayFooterAlert", obj);
                            })
                        }

                        const obj = {
                            title: _vue.lang.modal_title_unassignSEData,
                            text: _vue.lang.alert_unassignSEData,
                            type: "sure",
                            buttons: 2,
                            size: "sm",
                            funcYes: unassignFunc,
                            funcNo: ""
                        };

                        _vue.$store.dispatch("showAlert", obj);
                        
                        
                    }
                }
                
            ]


            var option = {};
            option.paging = false;
            option.info = false;
            option.dom = 'fB<t>';
            option.order = [0, "asc"];
            option.data = this.searchedDetails;
            option.myColumnFormats = this.columns;
            option.select = false;
            option.columns = this.colsAssign;
            option.columnDefs = columnDefs;
            option.buttons = buttons;

            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_' + this.id).DataTable(option);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            //this.mainTable.column( 0 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

        },

    }

}
</script>
<style lang="scss">
.SearchedSEDetailsTableComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .img-thumbnail {
        max-width: 160px;
        max-height: 160px;

        margin-top: 3px;
        margin-bottom: 3px;

    }

    .imageSVG {
        padding: 10px;
    }
}</style>



// WEBPACK FOOTER //
// src/components/shared/SearchedSEDetailsTableComponent.vue